import { create } from 'zustand'
import type { Donation } from '../types/donation'

type State = {
  donations: Array<Donation>
  add: (donation: Donation) => void
  update: (donation: Donation) => void
  updateMany: (donations: Array<Donation>) => void
  remove: (id: string) => void
  setDonations: (donations: Array<Donation>) => void
}

const initial: Array<Donation> = []

export const useDonationsStore = create<State>((set, get) => ({
  donations: initial,
  add: (donation) => {
    set({ donations: [...get().donations, donation] })
    return donation
  },
  update: (donation) =>
    set({
      donations: get().donations.map((x) =>
        x._id === donation._id ? { ...x, ...donation } : x,
      ),
    }),
  updateMany: (updatedDonations) =>
    set({
      donations: get().donations.map((x) => {
        const updated = updatedDonations.find((u) => u._id === x._id)
        return updated ? { ...x, ...updated } : x
      }),
    }),
  remove: (id) =>
    set({ donations: get().donations.filter((x) => x._id !== id) }),
  setDonations: (donations) => set({ donations }),
}))
